<template>
  <div class="appdev-box">
    <div class="en-title">{{ "APP development".toUpperCase() }}</div>
    <div class="cn-title">APP开发</div>
    <div class="content" v-html="cleanHtmlText(data.content)"></div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
@import url("./index.scss");
</style>
